import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { getJoinLink } from '../linkUtils';
import { useWithButtonAnalytics } from '../hooks/useWithButtonAnalytics';

export const JoinButton: FC<{
	contentId: string;
	shareToken?: string;
	cloudId: string;
	spaceKey?: string | null;
	renderLocation: string;
	contentType?: string | null;
	isContentIdRemovalEnabled?: boolean;
}> = ({
	contentId,
	shareToken,
	cloudId,
	spaceKey,
	renderLocation,
	contentType,
	isContentIdRemovalEnabled,
}) => {
	const { sendButtonUIEvent } = useWithButtonAnalytics({
		actionSubjectId: 'joinTeamButton',
		contentId: isContentIdRemovalEnabled && shareToken ? shareToken : contentId,
		renderLocation,
		contentType,
	});

	return (
		<Button
			href={getJoinLink(contentId, cloudId, spaceKey, contentType)}
			onClick={sendButtonUIEvent}
			appearance="primary"
			target="_blank"
		>
			<FormattedMessage
				id="external-share.join.button"
				description="button label text for a CTA to join an organization's Confluence site"
				defaultMessage="Join your team"
			/>
		</Button>
	);
};
